import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelper } from 'src/app/services/core/jwt-helper.service';

@Component({
	selector: 'app-notice-of-privacy-practices',
	templateUrl: './notice-of-privacy-practices.component.html',
	styleUrls: ['./notice-of-privacy-practices.component.scss'],
})
export class NoticeOfPrivacyPracticesComponent implements OnInit {
	isUserLoggedIn = false;
	constructor(
		private router: Router,
		private jwtHelper: JwtHelper
	) {}

	ngOnInit() {
		const epmsId = this.jwtHelper.getEpmsId();
		if (epmsId) {
			this.isUserLoggedIn = true;
		} else {
			this.isUserLoggedIn = false;
		}
	}
}
